<template>
  <div>
    <el-upload
      :action="url"
      :show-file-list="showFileList"
      :on-success="handleAvatarSuccess"
      :on-error="handleError"
      :before-upload="beforeAvatarUpload"
      :headers="uploadHeader()"
      :multiple="false"
      :on-exceed="handleExceed"
      :accept="accept"
      :data="data"
    >
      <slot name="uploadContent"></slot>
    </el-upload>
  </div>
</template>

<script>
import Util from '@lib/util.js';
import BaseApi from '@lib/baseApi.js';
export default {
  data() {
    return {
      data: {},
      loading: false,
    };
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 10,
      // mb
    },
    showFileList: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: '',
    },
    fileType: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    handleAvatarSuccess(res, file) {
      this.$store.commit('showLoading', false);
      if (res.code == 200) {
        this.$emit('uploadSuccess', res);
      } else {
        if (res.code == 102 || res.code == 103) {
          window.location.href = '/verification/login';
        } else {
          this.$message.error(res.message || '上传失败');
        }
      }
    },
    handleError() {
      this.$store.commit('showLoading', false);
      this.$message.error('上传失败');
    },
    // 上传前校验
    beforeAvatarUpload(file) {
      let fileName = file.name.toLowerCase();
      // 校验大小
      if (file.size / 1024 / 1024 > this.size) {
        return this.$message.error(`上传的pdf文件不能超过${this.size}M!`);
      } else {
        this.$store.commit('showLoading', true);
      }
      // 校验文件格式
      if (this.fileType) {
        let fileExtension = '';
        if (fileName.lastIndexOf('.') > -1) {
          fileExtension = fileName.slice(fileName.lastIndexOf('.') + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          // if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`,
          );
          return false;
        }
        return true;
      }
    },
    uploadHeader() {
      return {
        token: localStorage.token || 'mVYUzIuJCAmoOjgiI0xaaW8mfqJGPq',
        'X-CSRF-Token': sessionStorage.token,
        'request-id': Util.getUID(),
      };
    },
    handleExceed() {
      this.$message.error(`超出文件限制数量`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
